
<b-row class="rotation-product" :class="{ 'selected-product': isSelected }">
  <b-col cols="3">
    <img
      :src="product.image"
      class="rotation-subscription-modal__form__product__image"
      :class="{ 'small-product-img': !isSelected }"
    >
  </b-col>
  <b-col cols="6">
    <b-row class="justify-center pt-3 pb-3">
      <h3 v-if="!loading">
        {{ product.title }} - $ {{ completePrice }}
      </h3>
    </b-row>
    <b-row
      v-show="modifiers.length > 0 && isSelected && !loading"
      class="w-100 mt-3 d-none d-md-block"
    >
      <b-row v-show="loading" key="loading" align-h="center" class="w-100">
        <SmallSpinner :size="50" centered />
      </b-row>
      <b-col>
        <product-modifiers
          v-show="modifiers.length > 0 && isSelected && !loading"
          v-model="modifiers"
          :validated.sync="modifiersValid"
          class="w-100"
        />
      </b-col>
    </b-row>
  </b-col>
  <b-col cols="3" class="select-rotation-product" @click="emitSelection">
    <b-form-checkbox
      v-model="isSelected"
      class="mb-4"
      switch
      size="lg"
      @change="emitSelection"
    />
  </b-col>
  <template>
    <!-- This section for mobile version -->
    <div class="mx-2 w-100 d-md-none mt-3">
      <b-row v-show="loading" key="loading" align-h="center" class="w-100">
        <SmallSpinner :size="50" centered />
      </b-row>
      <b-row
        v-show="modifiers.length > 0 && isSelected && !loading"
        class="w-100 mt-3"
      >
        <b-col>
          <product-modifiers
            v-show="modifiers.length > 0 && isSelected && !loading"
            v-model="modifiers"
            :validated.sync="modifiersValid"
            class="w-100"
          />
        </b-col>
      </b-row>
    </div>
  </template>
</b-row>
